import React from "react";
import { inject, observer } from "mobx-react";

import { builtInStores } from "../../stores";
import { utils } from "@intrasync/utils";

interface Store {
  name: string;
}

const excludeStoreNames = ["syncRootStore", "loginSyncRootStore"];

let allIncludedStores: string[] = [];
let setupDone: string = "incomplete";

/**
 * Adds the names of included stores to an array.
 *
 * @param {Object[]} appStores - The array of app stores.
 * @param {Object[]} serviceStores - The array of service stores.
 * @returns {Promise<boolean>} - A promise that resolves to the array of all included store names.
 */
export const setupInjectStores = (
  appStores: Store[],
  serviceStores: Store[]
): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    try {
      // console.log('setupInjectStores called');
      const appStoreNames = appStores.map((store) => store.name);
      const serviceStoreNames = serviceStores
        .filter((service) => service.name)
        .map((service) => utils.servicePathToStoreName(service.name));
      // console.log("serviceStoreNames", serviceStoreNames);
      allIncludedStores = utils.uniqueArray([
        ...appStoreNames,
        ...serviceStoreNames,
        ...builtInStores,
      ]) as string[];
      // console.log("allIncludedStores", allIncludedStores);
      setupDone = "complete";
      resolve(true);
    } catch (error) {
      console.error("Error setting up stores", error);
      setupDone = "error";
      reject(error);
    }
  });
};

/**
 * injectStores - Wraps Component with observer and injects any store used in the export
 * Returns any to bypass TypeScript strict checking since strict mode is disabled
 */
function injectStores(Comp: any): any {
  // console.log("is setupDone", setupDone);
  // console.log("injectStores Comp", Comp);
  const componentAsString = String(Comp);
  //   const stores = [];
  const hasStore = componentAsString.includes("Store");
  if (hasStore) {
    // console.log('injectStores Comp hasStore');
    // console.log('allIncludedStores', allIncludedStores);
    const storeRegex = componentAsString.matchAll(/\w*Store\b/g);
    const storeList = [];
    for (const storeMatch of storeRegex) {
      const storeName = storeMatch[0];
      // console.log('storeName', storeName);
      if (
        allIncludedStores.includes(storeName) ||
        builtInStores.includes(storeName)
      ) {
        storeList.push(storeName);
      } else {
        if (!excludeStoreNames.includes)
          console.log("storeName was not found:", storeName);
      }
    }
    // console.log('injectStores storeList', storeList);
    const uniqueStores: string[] = utils.uniqueArray(storeList) as string[];
    if (uniqueStores.length < 1) {
      return observer(Comp);
    }

    // console.log('injectStores uniqueStores', uniqueStores);
    return inject(...uniqueStores)(observer(Comp));
  }
  return observer(Comp);
}

export default injectStores;
